import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  closePopup() {
    $('.popover-link-service-category')
      .data('popover')
      .hide();
  }
}
